const fr = {
  "common.cancel": "Annuler",
  "common.close": "Fermer",
  "common.on": "Activé",
  "common.off": "Désactivé",
  "common.show": "Afficher",
  "common.hide": "Masquer",
  "common.hint": "Astuce",
  "common.showHint": "Afficher l'astuce",
  "common.labelCountShowHint": "{label} {count}. Afficher l'astuce",

  "duration.minutes_one": "{count} minute",
  "duration.minutes_other": "{count} minutes",
  "duration.hours_one": "{count} heure",
  "duration.hours_other": "{count} heures",

  "splash.description":
    "Aeterna Invicta cherche à réunir les aspects les meilleurs et les plus intéressants de Magic: The Gathering et de Path of Exile dans un jeu de cartes à collectionner. Construis des decks, découvre des synergies et joue bien tes cartes pour l'emporter sur ton adversaire.",
  "splash.tagline": "Deviens éternel et incontesté !",
  "splash.tutorials": "Nouveau joueur ? Clique ici pour les tutoriels !",
  "splash.enterGame": "Entrer dans le jeu",

  "nav.collapse": "Réduire la navigation",
  "nav.expand": "Développer la navigation",
  "nav.summary": "Résumé",
  "nav.game": "Jeu",
  "nav.queue": "File d'attente",
  "nav.decks": "Decks",
  "nav.library": "Bibliothèque",
  "nav.achievements": "Quotidiennes et succès",
  "nav.customize": "Personnaliser",
  "nav.marketplace": "Marché",
  "nav.social": "Social",
  "nav.ranking": "Classement",
  "nav.settings": "Paramètres",
  "nav.workshop": "Atelier",
  "nav.community": "Communauté",
  "nav.support": "Assistance",

  "hud.gameLog": "Journal de partie",
  "hud.patchNotes": "Notes de mise à jour",
  "hud.showNavbar": "Afficher la barre de navigation",
  "hud.hideNavbar": "Masquer la barre de navigation",
  "hud.queued": "En file",
  "hud.forfeit": "Abandonner",
  "hud.leave": "Quitter",
  "hud.leaveSpectate": "Quitter le mode spectateur",
  "hud.serverMessages": "Messages du serveur",
  "hud.serverMessagesNew": "Messages du serveur (nouveau)",

  "serverMessages.title": "Messages du serveur",
  "serverMessages.kindAdmin": "Message du serveur",
  "serverMessages.kindMaintenance": "Maintenance du serveur",
  "serverMessages.inProgress":
    "Maintenance du serveur en cours. Le serveur peut redémarrer à tout moment.",
  "serverMessages.beginsIn": "La maintenance du serveur commence dans",
  "serverMessages.empty": "Aucun message du serveur pour le moment.",
  "serverMessages.view": "Voir les messages du serveur",
  "serverMessages.template.patchApplied":
    "Un nouveau patch est disponible. Actualise la page ou redémarre l'application pour charger la dernière version.",
  "serverMessages.template.maintenanceComplete":
    "La maintenance du serveur est terminée. Merci pour ta patience !",
  "serverMessages.template.restartingNow":
    "Le serveur redémarre maintenant. Tu seras reconnecté automatiquement dans un instant.",
  "serverMessages.template.maintenanceExtended":
    "La maintenance du serveur prend plus de temps que prévu. Nous serons bientôt de retour.",
  "serverMessages.template.investigatingIssue":
    "Nous avons connaissance d'un problème et nous enquêtons. Merci pour ta patience.",
  "serverMessages.template.reportBugs":
    "Merci de jouer à Aeterna Invicta ! Signale tout bug depuis la page Assistance.",
  "serverMessages.template.maintenanceCountdown":
    "La maintenance du serveur commence dans {duration}. Termine tes parties d'ici là.",
  "serverMessages.template.maintenanceStarting":
    "La maintenance du serveur commence maintenant. Le serveur peut redémarrer à tout moment.",
  "serverMessages.template.maintenanceCancelled":
    "La maintenance prévue du serveur a été annulée.",

  "completion.achievement": "Succès accompli",
  "completion.daily": "Quotidienne accomplie",

  "settings.title": "Paramètres",
  "settings.backToMenu": "Retour aux paramètres",
  "settings.section.account": "Compte",
  "settings.section.general": "Général",
  "settings.section.gameplay": "Jeu",
  "settings.section.display": "Affichage",
  "settings.section.controls": "Commandes et accessibilité",
  "settings.section.social": "Social et confidentialité",
  "settings.section.danger": "Zone de danger",
  "settings.musicVolume.label": "Volume de la musique",
  "settings.soundVolume.label": "Volume des sons",
  "settings.volume.decrease": "Baisser {label}",
  "settings.volume.increase": "Augmenter {label}",
  "settings.volume.description": "Enregistré sur cet appareil.",

  "settings.language.label": "Langue",
  "settings.language.description":
    "Choisis la langue des menus et des messages. Les noms et les textes des cartes restent en anglais.",

  "settings.account.label": "Compte",
  "settings.account.guestSuffix": " (Invité)",
  "settings.account.guestDescription":
    "La progression invité dure jusqu'à 24 heures. Te déconnecter supprime définitivement cette sauvegarde invité.",
  "settings.account.savedDescription":
    "Connecté avec un compte enregistré sur cet appareil.",
  "settings.account.createAndKeep": "Créer un compte et garder la progression",
  "settings.account.migratePrompt":
    "Crée un compte et transfère-y ta progression actuelle.",
  "settings.account.username": "Nom d'utilisateur",
  "settings.account.password": "Mot de passe",
  "settings.account.migrating": "Migration…",
  "settings.account.createAccount": "Créer un compte",
  "settings.account.changePasswordPrompt": "Change ton mot de passe.",
  "settings.account.currentPassword": "Mot de passe actuel",
  "settings.account.newPassword": "Nouveau mot de passe",
  "settings.account.confirmNewPassword": "Confirmer le nouveau mot de passe",
  "settings.account.saving": "Enregistrement…",
  "settings.account.updatePassword": "Mettre à jour le mot de passe",
  "settings.account.changePassword": "Changer le mot de passe",
  "settings.account.logOut": "Se déconnecter",
  "settings.account.logOutGuestConfirm":
    "Te déconnecter et supprimer définitivement ce compte invité et toute sa progression ?",
  "settings.account.logOutConfirm": "Te déconnecter de ce compte sur cet appareil ?",
  "settings.account.confirmLogOut": "Confirmer la déconnexion",

  "settings.music.label": "Musique",
  "settings.music.description":
    "Joue une musique de fond. Les morceaux du menu et des parties forment des playlists distinctes, lues en aléatoire avec fondu enchaîné, y compris en entrant dans une partie ou en la quittant.",

  "settings.sound.label": "Son",
  "settings.sound.description":
    "Joue des effets sonores pour les pioches et les autres événements de partie.",
  "settings.sound.skipTrack": "Passer au morceau suivant",

  "settings.workshop.label": "Atelier",
  "settings.workshop.description":
    "Affiche ou masque le bouton Atelier dans la barre de navigation.",

  "settings.quickUse.label": "Afficher l'utilisation rapide",
  "settings.quickUse.description":
    "Affiche une dépense rapide optionnelle pour les ressources et/ou l'attaque. Cela t'aide surtout à utiliser rapidement tes équipements ou capacités si tu privilégies l'efficacité plutôt que la qualité.",

  "settings.hints.label": "Astuces",
  "settings.hints.description":
    "Active les boutons d'astuce contextuels pendant les parties. Touche une icône ? pour afficher une aide sur l'interface à proximité.",

  "settings.matchGuides.label": "Guides de partie",
  "settings.matchGuides.auto": "Auto",
  "settings.matchGuides.description":
    "Fait briller les cartes jouables, les équipements et capacités utilisables et Fin du tour, avec un encadré d'aide repliable pendant les parties contre le CPU ou des joueurs. Auto affiche les guides pour les comptes invités et pendant tes {games} premières parties.",

  "settings.cardNames.label": "Noms des cartes",
  "settings.cardNames.description":
    "Affiche ou masque le nom des cartes dans ta main et des cartes jouées dans les emplacements d'équipement.",

  "settings.leftHanded.label": "Mode gaucher",
  "settings.leftHanded.description":
    "Déplace les boutons Fin du tour et Emote à gauche et ta main à droite pendant les parties.",

  "settings.theme.label": "Thème",
  "settings.theme.dark": "Sombre",
  "settings.theme.light": "Clair",
  "settings.theme.description": "Bascule entre différents thèmes.",

  "settings.graphics.label": "Qualité graphique",
  "settings.graphics.auto": "Auto",
  "settings.graphics.high": "Élevée",
  "settings.graphics.medium": "Moyenne",
  "settings.graphics.low": "Basse",
  "settings.graphics.description":
    "Une qualité plus basse réduit les mouvements d'arrière-plan, les foils animés, les lueurs et le flou pour garder des parties fluides sur les appareils lents. Auto choisit un niveau pour cet appareil et le baisse si les parties saccadent. Enregistré par appareil.",
  "settings.graphics.autoCurrent": "Niveau actuel : {tier}.",
  "settings.graphics.autoLowered":
    "Graphismes réduits à {tier} pour garder la partie fluide. Tu peux modifier cela dans les Paramètres.",

  "settings.foil.label": "Effets foil",
  "settings.foil.minimum": "Minimum",
  "settings.foil.maximum": "Maximum",
  "settings.foil.description":
    "Maximum anime le reflet foil dans le Constructeur de deck, les parties et le résumé. La Collection, la Bibliothèque et les autres grilles denses restent statiques. Minimum garde les foils statiques partout. Désactivé ne garde que les traitements de couleur statiques comme le niveau de gris ou la couleur alternative.",

  "settings.toasts.label": "Notifications",
  "settings.toasts.cardOnly": "Carte seule",
  "settings.toasts.textOnly": "Texte seul",
  "settings.toasts.all": "Tout",
  "settings.toasts.description":
    "Choisis quelles pop-ups de partie et d'action s'affichent. Désactivé masque toutes les notifications. Carte seule affiche de petits aperçus de cartes. Texte seul affiche les notifications de message. Tout affiche les deux.",

  "settings.toastSpeed.label": "Vitesse des notifications",
  "settings.toastSpeed.fast": "Rapide",
  "settings.toastSpeed.standard": "Standard",
  "settings.toastSpeed.description":
    "Rapide affiche brièvement les notifications puis les estompe. Standard garde la durée d'affichage habituelle. Touche ou clique à tout moment pour les fermer plus tôt.",
  "settings.handDisplay.label": "Affichage de la main",
  "settings.handDisplay.drawer": "Tiroir",
  "settings.handDisplay.dynamic": "Dynamique",
  "settings.handDisplay.description":
    "Tiroir garde ta main entièrement visible ; utilise la flèche à côté pour descendre les cartes jusqu’à leur nom. Dynamique garde la main à moitié cachée et lève une carte au survol ou au toucher.",
  "match.view.hideHand": "Masquer la main",
  "match.view.showHand": "Afficher la main",

  "settings.fullscreen.label": "Forcer le plein écran",
  "settings.fullscreen.description":
    "Force le plein écran sur ordinateur ou mobile, ce qui masque la barre d'adresse/URL.",

  "settings.controller.label": "Manette",
  "settings.controller.connected": "Connectée",
  "settings.controller.none": "Aucune détectée",
  "settings.controller.description":
    "La croix directionnelle parcourt les noms des paramètres. A ouvre les choix de ce paramètre, puis A sélectionne une valeur. Les champs de texte ouvrent un clavier à l'écran (A pour taper, B pour fermer). Select ou Start bascule entre la barre de navigation et la vue actuelle.",

  "settings.chat.label": "Chat",
  "settings.chat.turnOff": "Désactiver le chat",
  "settings.chat.reviewTerms": "Consulter les conditions du chat",
  "settings.chat.muted": "Le chat a été désactivé pour ton compte.",
  "settings.chat.on":
    "Le chat est activé. Désactiver le chat masque tous les messages et t'empêche d'en envoyer. Tu devras consulter et accepter à nouveau les conditions du chat pour le réactiver.",
  "settings.chat.off":
    "Le chat est désactivé. Consulte et accepte les conditions du chat pour voir et envoyer des messages.",
  "settings.chat.locked":
    "Le chat est désactivé. Il se débloque quand ton compte a au moins 24 heures, ou après {games} parties terminées sans abandon.",

  "settings.blocked.label": "Joueurs bloqués",
  "settings.blocked.unblock": "Débloquer",
  "settings.blocked.description":
    "Les messages de chat et les emotes en partie des joueurs bloqués te sont masqués, et ils ne peuvent pas te défier. Bloque un joueur depuis son profil dans Social, Classement, le chat ou l'aperçu du joueur pendant une partie.",

  "settings.adventure.label": "Aventure",
  "settings.adventure.reset": "Réinitialiser l'Aventure",
  "settings.adventure.description":
    "Réinitialiser l'Aventure supprime ta sauvegarde d'Aventure et te permet de tout recommencer. Si tu as commencé une partie en mode Aventure, toute ta sauvegarde d'Aventure sera réinitialisée (nouvelle carte, inventaire, aucun effet, etc.).",
  "settings.adventure.none": "Aucune sauvegarde d'Aventure à réinitialiser.",
  "settings.adventure.confirmTitle": "Réinitialiser l'Aventure ?",
  "settings.adventure.confirmBody":
    "Cela supprime définitivement ta sauvegarde d'Aventure, y compris ta progression sur la carte, ton Inventaire, ton Deck d'Aventure, ton Or et toute rencontre ou tout combat d'Aventure en cours. Tu recommenceras depuis le début.",

  "settings.deleteAccount.label": "Supprimer le compte",
  "settings.deleteAccount.description":
    "Supprime définitivement ce compte, ses identifiants et toute la progression. Cette action est irréversible.",
  "settings.deleteAccount.typeUsername": "Saisis ton nom d'utilisateur ({username})",
  "settings.deleteAccount.deleting": "Suppression…",
  "settings.deleteAccount.forever": "Supprimer le compte définitivement",

  "deck.aspect": "Aspect",
  "deck.equipment": "Équipement",
  "deck.ability": "Capacité",
  "deck.defaultName": "Deck",
  "deck.newDeck": "Nouveau deck",
  "deck.totalPower": "Puissance totale",
  "deck.filters.allCards": "Toutes les cartes",
  "deck.filters.allAttributes": "Tous les attributs",
  "deck.attr.strength": "Force",
  "deck.attr.dexterity": "Dextérité",
  "deck.attr.wisdom": "Sagesse",
  "deck.attr.neutral": "Neutre",
  "deck.filters.allResources": "Toutes les ressources",
  "deck.filters.allCosts": "Tous les coûts",
  "deck.filters.allCostsResources": "Tous les coûts/ressources",
  "deck.filters.fewer": "Moins de filtres",
  "deck.filters.more": "Plus de filtres",
  "deck.filters.holoUnlocked": "Holo débloqué",
  "deck.filters.cardsUnlocked": "Cartes : débloquées",
  "deck.filters.cardsLocked": "Cartes : verrouillées",
  "deck.filters.cardsAll": "Cartes : toutes",
  "deck.filters.clear": "Effacer les filtres",
  "deck.filters.searchPlaceholder": "Rechercher nom, effet, coût…",
  "deck.filters.allSlots": "Tous les emplacements",
  "deck.filters.allItemTypes": "Tous les types d'équipement",
  "deck.filters.allTiers": "Tous les rangs",
  "deck.filters.allKinds": "Tous les genres",
  "deck.kind.active": "Active",
  "deck.kind.augment": "Augmentation",
  "deck.kind.essence": "Essence",
  "deck.filters.allTypes": "Tous les types",
  "deck.filters.allEffects": "Tous les effets",
  "deck.filters.sortBy": "Tri : {label}",
  "deck.catalog.resultCount_one": "{count} carte",
  "deck.catalog.resultCount_other": "{count} cartes",
  "deck.variant.label": "Variante",
  "deck.variant.base": "Base",
  "deck.variant.confirm": "Confirmer",
  "deck.pager.previous": "Page précédente",
  "deck.pager.next": "Page suivante",
  "deck.pager.pageOf": "Page {page}/{total}",
  "deck.pager.perPage": "{n} par page",
  "deck.pager.all": "Tout",
  "deck.share.exportTitle": "Exporter le deck",
  "deck.share.importTitle": "Importer un deck",
  "deck.share.pastePlaceholder": "Colle le JSON du deck",
  "deck.share.copied": "Copié",
  "deck.share.copy": "Copier",
  "deck.share.import": "Importer",
  "deck.analyze.none": "Aucun",
  "deck.analyze.noOutputs": "Aucun rendement d'action mesurable.",
  "deck.analyze.output": "Rendement",
  "deck.analyze.avgPerCard": "Moy. / carte",
  "deck.analyze.total": "Total",
  "deck.analyze.sectionMeta": "{count} cartes · Puissance {power}",
  "deck.analyze.avgCost": "Coût moy. {cost}",
  "deck.analyze.kinds": "Genres",
  "deck.analyze.boardSlots": "Emplacements du plateau",
  "deck.analyze.equipmentSlots": "Emplacements d'équipement",
  "deck.analyze.attributes": "Attributs",
  "deck.analyze.typesPresent": "Types présents",
  "deck.analyze.averageOutputs": "Rendement moyen des actions",
  "deck.analyze.title": "Analyse · {name}",
  "deck.analyze.overview": "{count} cartes · Puissance {power}/{max}",
  "deck.analyze.attributesLabel": "Attributs :",
  "deck.analyze.typesLabel": "Types :",
  "deck.analyze.aspectMeta": "{name} · Puissance {power}",
  "deck.analyze.noneSelected": "Aucun sélectionné",
  "deck.analyze.types": "Types",
  "deck.analyze.pickAspect": "Choisis un Aspect pour l'inclure ici.",
  "deck.recommend.unknownCard": "Carte inconnue",
  "deck.recommend.title": "Changements recommandés · {name}",
  "deck.recommend.aspectUnchanged": "Aspect · Inchangé",
  "deck.recommend.swaps": "Échanges",
  "deck.recommend.loading": "Recherche d'échanges compatibles…",
  "deck.recommend.emptyTitle": "Aucun échange compatible trouvé.",
  "deck.recommend.emptyBody": "Aucune des cartes que tu possèdes ne convient mieux à ce deck sans perdre en couverture d'emplacements, en soutien de ressources ou en marge de Puissance. Ton deck est inchangé.",
  "deck.recommend.staleNotice": "Ton deck, les données des cartes ou ta collection ont changé depuis cet aperçu.",
  "deck.recommend.recommendAgainHint": "Relance la recommandation pour obtenir de nouveaux échanges.",
  "deck.recommend.exhausted": "Aucun autre échange trouvé. La dernière proposition reste affichée.",
  "deck.recommend.equipmentSlot": "Emplacement d'équipement {n}",
  "deck.recommend.abilitySlot": "Emplacement de capacité {n}",
  "deck.recommend.remove": "Retirer",
  "deck.recommend.add": "Ajouter",
  "deck.recommend.whyAdd": "Pourquoi ajouter",
  "deck.recommend.whyRemove": "Pourquoi retirer",
  "deck.recommend.disclaimer": "Les suggestions suivent les liens entre les cartes et ne garantissent pas une amélioration. Appliquer met à jour l'éditeur ; enregistre pour conserver les changements.",
  "deck.recommend.apply": "Appliquer les changements",
  "deck.recommend.again": "Recommander à nouveau",
  "deck.recommend.tryAgain": "Réessayer",
  "deck.recommend.button": "Recommander des changements",
  "deck.recommend.buttonTitle": "Suggérer 2–4 échanges de cartes compatibles",
  "deck.recommend.needsValidDeck": "Recommander des changements nécessite un deck complet et valide.",
  "deck.slot.empty": "Vide",
  "deck.slot.deckSlot": "Emplacement du deck",
  "deck.slot.clear": "Vider l'emplacement",
  "deck.slot.replaceCard": "Remplacer la carte",
  "deck.picker.replaceAspect": "Remplacer l'Aspect",
  "deck.picker.chooseAspect": "Choisir un Aspect",
  "deck.picker.replaceEquipmentSlot": "Remplacer l'emplacement d'équipement {n}",
  "deck.picker.chooseEquipmentSlot": "Choisir l'emplacement d'équipement {n}",
  "deck.picker.replaceAbilitySlot": "Remplacer l'emplacement de capacité {n}",
  "deck.picker.chooseAbilitySlot": "Choisir l'emplacement de capacité {n}",
  "deck.picker.hideFilters": "Masquer les filtres/la recherche",
  "deck.picker.showFilters": "Afficher les filtres/la recherche",
  "deck.picker.suggest": "Suggérer des cartes",
  "deck.sort.name": "Tri : Nom",
  "deck.sort.type": "Tri : Type",
  "deck.sort.attribute": "Tri : Attribut",
  "deck.sort.resources": "Tri : Ressources",
  "deck.sort.cost": "Tri : Coût",
  "deck.sort.power": "Tri : Puissance",
  "deck.sort.slot": "Tri : Emplacement",
  "deck.sort.kind": "Tri : Genre",
  "deck.sort.holo": "Tri : Nombre de holos",
  "deck.builder.title": "Constructeur de deck",
  "deck.builder.setDefault": "Définir par défaut",
  "deck.builder.clone": "Dupliquer",
  "deck.builder.save": "Enregistrer",
  "deck.builder.delete": "Supprimer",
  "deck.builder.export": "Exporter",
  "deck.builder.analyze": "Analyser",
  "deck.builder.default": "Par défaut",
  "deck.builder.unsaved": "Non enregistré",
  "deck.builder.deleteTitle": "Supprimer le deck ?",
  "deck.builder.deleteBody": "Supprimer définitivement {name}. Cette action est irréversible.",
  "match.board.healthCost": "{amount} de santé",
  "match.board.alreadyPlayedAbility": "Capacité déjà jouée ce tour-ci.",
  "match.board.tagInherent": "inhérente",
  "match.board.tagCombo": "combo",
  "match.board.tagLevel": "Niv. {level}",
  "match.board.tagActiveMinion": "Actif : {name} {hp}",
  "match.board.tagActiveAura": "Actif : {name}",
  "match.board.slotTitleCanLevelUp": "Peut monter de niveau · sélectionne pour voir les actions",
  "match.board.slotTitleEmpowerArmor": "Renforcer cette carte d'Armure physique",
  "match.board.slotTitleLinkedAugment": "Augmentation liée correspondante",
  "match.board.slotTitleSlotHere": "Placer la capacité ici",
  "match.board.mismatch": "Incompatible",
  "match.board.expendedSuffix": " · dépensé",
  "match.board.auraActiveTitle": "{name} · Aura active",
  "match.board.linkedActiveUsed": "{name} · active liée utilisée",
  "match.board.slotTitleInert": "{name} · inactive hors de l'emplacement principal",
  "match.board.costTitle": "Coût {cost}",
  "match.board.emptyAbilitySlot": "Emplacement de capacité vide",
  "match.board.fletchCounter_one": "{count} charge d'Empennage",
  "match.board.fletchCounter_other": "{count} charges d'Empennage",
  "match.board.activeBadge": "Actif",
  "match.board.you": "TOI",
  "match.board.opp": "ADV",
  "match.board.timerMulligan": "Minuteur de mulligan",
  "match.board.timerTurn": "Minuteur du tour",
  "match.board.timerMatch": "Minuteur de partie",
  "match.board.mulligan": "Mulligan",
  "match.board.yourTurn": "Ton tour",
  "match.board.playerTurn": "Tour de {name}",
  "match.board.firstPlayerWillBe": "1er joueur : {name} · ",
  "match.board.round": "Manche {round}",
  "match.board.peekEquipment": "Équipement",
  "match.board.noEquipment": "Aucun équipement",
  "match.board.peekAbilities": "Capacités",
  "match.board.noAbilities": "Aucune capacité",
  "match.board.noOccupiedSlots": "Aucun emplacement occupé",
  "match.board.healthOrbLabel": "Santé {hp} sur {maxHp}",
  "match.board.quests": "Quêtes",
  "match.board.tapAgainToExpend": "Touche à nouveau pour dépenser : {action}",
  "match.board.targetAspect": "Cibler l'Aspect",
  "match.board.aspect": "Aspect",
  "match.board.aspectSlotLabel": "Emplacement d'Aspect",
  "match.board.aspectSlot": "Emplacement d'Aspect",
  "match.board.slotWeapon": "Arme",
  "match.board.slotArmor": "Armure",
  "match.board.slotTrinket": "Bibelot",
  "match.board.minion": "Serviteur",
  "match.board.aura": "Aura",
  "match.board.expend": "Dépenser",
  "match.board.minionHealthLabel": "Santé de {name} : {hp} sur {maxHp}",
  "match.board.auraActiveLabel": "{name} actif",
  "match.board.hexed": "Ensorcelé",
  "match.board.expendCost": "Dépenser +{cost}",
  "match.board.equipHere": "Équiper ici",
  "match.board.slotTitle": "Emplacement {slot}",
  "match.board.slotAriaLabel": "Emplacement {slot}",
  "match.board.quickRefresh": "RAFRAÎCHIR",
  "match.board.quickEncore": "ENCORE",
  "match.board.quickSlotDamage": "DÉG. EMPL.",
  "match.board.quickRepair": "RÉPARER",
  "match.board.gainResources": "Gagner des ressources",
  "match.board.dealDamage": "Infliger des dégâts",
  "match.board.heal": "Soigner",
  "match.board.physicalArmor": "Armure physique",
  "match.board.magicArmor": "Armure magique",
  "match.board.resolveTargetingFirst": "Termine d'abord le ciblage.",
  "match.board.equipmentBrokenCannotExpend": "Cet équipement est brisé et ne peut pas être dépensé.",
  "match.board.equipmentCannotExpend": "Cet équipement ne peut pas être dépensé.",
  "match.board.refreshRequiresExpended": "Rafraîchir nécessite un équipement dépensé.",
  "match.board.cannotUseAction": "Impossible d'utiliser cette action.",
  "match.board.equipmentAction": "Action d'équipement",
  "match.board.notEnoughPhysicalArmor": "Pas assez d'armure physique.",
  "match.board.examine": "Examiner",
  "match.board.deactivateAura": "Désactiver l'aura",
  "match.board.effectFallback": "Effet",
  "match.board.encore": "Encore",
  "match.board.slottedDamage": "+{amount} dégâts d'emplacement",
  "match.board.repair": "Réparer",
  "match.board.equipmentNotExpended": "L'équipement n'est pas dépensé.",
  "match.board.refresh": "Rafraîchir",
  "match.board.charge": "Charger",
  "match.board.discard": "Défausser",
  "match.board.levelUpAbility": "Monter la capacité de niveau",
  "match.board.empowerEquipment": "Renforcer l'équipement",
  "match.board.empowerAbility": "Renforcer la capacité",
  "match.board.unsummon": "Révoquer",
  "match.board.deactivate": "Désactiver",
  "match.board.alreadyActivated": "Déjà activé ce tour-ci.",
  "match.board.minionAlreadyActive": "Le serviteur est déjà actif.",
  "match.board.auraAlreadyActive": "L'aura est déjà active.",
  "match.board.hostEquipmentOccupied": "L'équipement hôte est occupé.",
  "match.board.unsummonMinionFirst": "Révoque d'abord le serviteur.",
  "match.board.deactivateAuraFirst": "Désactive d'abord l'aura.",
  "match.board.moveAbility": "Déplacer la capacité",
  "match.board.remainingActs": "Actions restantes :",
  "match.board.remainingEquip": "Équiper",
  "match.board.remainingAbility": "Capacité",
  "match.board.remainingExpendGear": "Dépenser équip.",
  "match.board.remainingActivateAbilities": "Activer cap.",
  "match.board.hintEquip": "Une fois par tour, équipe une carte Équipement de ta main sur un emplacement corporel vide.",
  "match.board.hintAbility": "Une fois par tour, place une Capacité de ta main sur ton plateau, ou déplace une Capacité placée vers un emplacement vide. Défausser une Capacité placée est gratuit et n'utilise pas cette action.",
  "match.board.hintExpendGear": "Chaque objet équipé peut être dépensé une fois par tour pour des ressources ou pour son effet de dépense. Plusieurs options de dépense sur un même objet ne comptent qu'une fois.",
  "match.board.hintActivateAbilities": "Chaque Capacité active placée et inutilisée qui peut encore être activée ce tour-ci. Tu dois toujours payer son coût pour l'activer.",
  "match.board.notEnoughResources": "Pas assez de ressources.",
  "match.board.effectNumber": "Effet {number}",
  "match.board.actionNumber": "Action {number}",
  "match.board.noEmptyAbilitySlots": "Aucun emplacement de capacité vide.",
  "match.board.selectEmptyAbilitySlot": "Sélectionne un emplacement de capacité vide.",
  "match.panel.aspect": "Aspect",
  "match.panel.aspectEmpty": "Aspect · Vide",
  "match.panel.equipment": "Équipement",
  "match.panel.slotEmpty": "{slot} · Vide",
  "match.panel.minion": "Serviteur",
  "match.panel.aura": "Aura",
  "match.panel.onEquipment": " · sur {name}",
  "match.panel.charges": "Charges",
  "match.panel.durability": "Durabilité",
  "match.panel.broken": " (Brisé)",
  "match.panel.unsummon": "Révoquer",
  "match.panel.deactivate": "Désactiver",
  "match.panel.gain": "Gagner",
  "match.panel.toast.resolveTargetingFirst": "Termine d'abord le ciblage.",
  "match.panel.toast.notEnoughPhysicalArmor": "Pas assez d'armure physique.",
  "match.panel.toast.refreshRequiresExpended": "Rafraîchir nécessite un équipement dépensé.",
  "match.panel.toast.equipmentCannotExpend": "Cet équipement ne peut pas être dépensé.",
  "match.panel.toast.resolvePendingChoiceFirst": "Termine d'abord le choix en attente.",
  "match.panel.refresh": "Rafraîchir",
  "match.panel.charge": "Charger",
  "match.panel.encore": "Encore",
  "match.panel.slottedDamageButton": "+{amount} dégâts d'emplacement",
  "match.panel.repair": "Réparer",
  "match.panel.discard": "Défausser",
  "match.panel.examine": "Examiner",
  "match.panel.traits": "Traits",
  "match.panel.aspectTraitTreeAria": "Arbre de traits de {name}",
  "match.panel.levelTrait": "Trait de niveau {level}",
  "match.panel.levelTraitLabel": "Niveau {level} : {label}",
  "match.panel.aspectBaseEffect": "Effet de base de l'Aspect",
  "match.panel.allocated": "Attribué",
  "match.panel.traitOption": "Option de trait",
  "match.panel.clickAnywhereToClose": "Clique n'importe où pour fermer",
  "match.panel.tapNodeHint": "Touche un nœud pour examiner les Traits et l'effet de base de l'Aspect.",
  "match.panel.viewArtAria": "Voir l'illustration de {name}",
  "match.panel.variant": "Variante",
  "match.panel.variantBase": "Base",
  "match.panel.expansionSetAria": "Extension {set}",
  "match.panel.set": "Extension",
  "match.panel.power": "Puissance",
  "match.panel.attributes": "Attributs",
  "match.panel.attribute": "Attribut",
  "match.panel.kind": "Genre",
  "match.panel.linksTo": "Lié à",
  "match.panel.or": "ou",
  "match.panel.matchingActiveAbilities": "Capacités actives correspondantes",
  "match.panel.slot": "Emplacement",
  "match.panel.boardSlotSub": "Emplacement de plateau {slot}",
  "match.panel.matchEffect": "Effet de partie",
  "match.panel.passive": "Passif",
  "match.panel.kindEffect": "Effet {kind}",
  "match.panel.effect": "Effet",
  "match.panel.effectLower": "effet",
  "match.panel.triggers": "Déclencheurs",
  "match.panel.expend": "Dépenser",
  "match.panel.equipmentActions": "Actions d'équipement",
  "match.panel.cardText": "Texte de la carte",
  "match.panel.invoke": "Invoquer",
  "match.panel.levelProgression": "Progression de niveau",
  "match.panel.traitTree": "Arbre de traits",
  "match.panel.tapArtToEnlarge": "Touche l'illustration pour l'agrandir",
  "match.panel.ability": "Capacité",
  "match.panel.health": "Santé",
  "match.panel.expendedThisTurn": "Dépensé ce tour-ci",
  "match.panel.minions": "Serviteurs",
  "match.panel.hostEquipment": "Équipement hôte · {name}",
  "match.panel.appliedEffects": "Effets appliqués",
  "match.panel.applyAbility": "Appliquer {name}",
  "match.panel.used": "Utilisé",
  "match.panel.activeMinionStatus": "Actif : {name} {hp}",
  "match.panel.activeStatus": "Actif : {name}",
  "match.panel.mismatch": "Incompatible",
  "match.panel.level": "Niveau",
  "match.panel.baseLevel": "Base {level}",
  "match.panel.status": "Statut",
  "match.panel.levelUpAbility": "Monter la capacité de niveau",
  "match.panel.exportGameLogTitle": "Télécharger un instantané JSON du journal de partie jusqu'à présent",
  "match.panel.exporting": "Exportation…",
  "match.panel.export": "Exporter",
  "match.panel.noActionsYet": "Aucune action pour l'instant.",
  "match.panel.quests": "Quêtes",
  "match.panel.eachTurn": "À chaque tour",
  "match.panel.eachTurnHint": "À accomplir dans n'importe quel ordre. Réinitialisé au début de ton prochain tour.",
  "match.panel.duringGame": "Pendant la partie",
  "match.panel.duringGameHint": "À accomplir une fois par partie, dans n'importe quel ordre.",
  "match.panel.chooseSlottedResource": "Choisis une ressource correspondant à une capacité placée.",
  "match.panel.convertNeutral": "Convertis 1 Neutre en un attribut de ton choix.",
  "match.panel.chooseFocusResourcePrompt": "Choisis Force, Dextérité ou Sagesse. Gagne 1 de cette ressource.",
  "match.panel.chooseIdentity": "Choisir l'Identité",
  "match.panel.chooseIdentityPrompt": "Choisis l'Identité. Cet équipement prend l'attribut principal choisi tant qu'il est équipé.",
  "match.panel.levelUp": "Niveau supérieur",
  "match.panel.levelN": "Niveau {level}",
  "match.panel.tierN": "Rang {tier}",
  "match.panel.tier": "Rang",
  "match.panel.selected": "Sélectionné",
  "match.panel.notChosen": "Non choisi",
  "match.panel.futureChoice": "Choix futur",
  "match.panel.traitChoiceHint": "Sélectionne un nœud brillant, puis Confirme pour verrouiller ton Trait.",
  "match.panel.traitTreeAria": "Arbre de traits",
  "match.panel.viewBoard": "Voir le plateau",
  "match.panel.confirmTrait": "Confirmer le Trait",
  "match.panel.clickOutsideToClose": "Clique à l'extérieur pour fermer",
  "match.panel.showLevelUpPrompt": "Afficher l'invite de niveau supérieur",
  "match.panel.hideLevelUpPrompt": "Masquer l'invite de niveau supérieur",
  "match.panel.levelUpAbilityPrompt": "Sélectionne une Capacité {attribute} en surbrillance et choisis Monter la capacité de niveau, ou Passer pour +3 XP.",
  "match.panel.empowerPhysicalArmorCard": "Renforcer une carte d'Armure physique",
  "match.panel.empowerEquipment": "Renforcer l'équipement",
  "match.panel.empowerPhysicalArmorHint": "Choisis une capacité placée surlignée en jaune qui octroie de l'Armure physique pour la faire monter de niveau, ou un équipement dont l'effet de dépense octroie de l'Armure physique pour augmenter cette armure de dépense de 1 (l'armure passive est inchangée), ou Passer pour +3 XP.",
  "match.panel.empowerEquipmentHint": "Choisis un équipement de Sagesse surligné en jaune qui octroie de l'Armure magique pour augmenter de 1 son Armure magique passive et de dépense, ou Passer pour +3 XP.",
  "match.panel.chargeResourceSpend": "{label} : {current}. Dépense {per} par unité pour gagner Force, Dextérité ou Sagesse.",
  "match.panel.allocateUpTo": "Attribue jusqu'à {max}. Reste {remaining}.",
  "match.panel.maxValue": "max {max}",
  "match.panel.confirm": "Confirmer",
  "match.panel.payFor": "Payer {name}",
  "match.panel.spendAnyFlex": "Dépense {amount} au choix parmi force, dextérité, sagesse ou neutre",
  "match.panel.remaining": "Reste {amount}",
  "match.panel.decreaseAria": "Diminuer {attribute}",
  "match.panel.increaseAria": "Augmenter {attribute}",
  "match.panel.hiddenCard": "Carte cachée",
  "match.panel.discardAndDraw": "Défausser et piocher",
  "match.panel.equip": "Équiper",
  "match.panel.slotAction": "Placer",
  "match.panel.plusOnePhysArmor": "+1 Armure phys.",
  "match.view.enemies": "Ennemis",
  "match.view.statusBleed": "Saignement {amount}",
  "match.view.statusPoison": "Poison {amount}",
  "match.view.statusBurn": "Brûlure {amount}",
  "match.view.statusChill": "Froid {amount}",
  "match.view.statusShock": "Choc {amount}",
  "match.view.statusWither": "Flétrissement {amount}",
  "match.view.statusHex": "Maléfice {amount}",
  "match.view.statusRegen": "Régén. {amount}",
  "match.view.regeneration": "Régénération",
  "match.view.wither": "Flétrissement",
  "match.view.enemyDefeated": "Vaincu",
  "match.view.enemySelectedTarget": "Cible sélectionnée",
  "match.view.enemySelect": "Sélectionner l'ennemi",
  "match.view.enemyExamine": "Examiner l'ennemi",
  "match.view.emptyEnemySlotAria": "Emplacement ennemi vide {slot}",
  "match.view.emptySlot": "Vide",
  "match.view.matchOver": "Partie terminée",
  "match.view.waitingForSummary": "En attente du résumé…",
  "match.view.resultDraw": "Égalité",
  "match.view.endedTimeout": "Temps écoulé",
  "match.view.endedCombat": "Combat",
  "match.view.tutorialComplete": "Tutoriel terminé",
  "match.view.tryAgain": "Réessayer",
  "match.view.victory": "Victoire",
  "match.view.defeat": "Défaite",
  "match.view.deckPower": "Puissance {total}/{max}",
  "match.view.deckAspectPower": "Aspect · Puissance {power}",
  "match.view.deckEquipmentPower": "Équipement ({cards}) · Puissance {power}",
  "match.view.deckAbilitiesPower": "Capacités ({cards}) · Puissance {power}",
  "match.view.noneRemaining": "Plus aucune",
  "match.view.you": "Toi",
  "match.view.winner": "Vainqueur",
  "match.view.board": "Plateau",
  "match.view.handCount": "Main ({n})",
  "match.view.deckCount": "Deck ({n})",
  "match.view.discardCount": "Défausse ({n})",
  "match.view.continue": "Continuer",
  "match.view.adNotCompleted": "La publicité n'a pas été regardée jusqu'au bout.",
  "match.view.adStartFailed": "Impossible de lancer la publicité.",
  "match.view.adExtraUnlock": "Regarde une publicité pour un déblocage supplémentaire",
  "match.view.unlockedCards_one": "{count} carte débloquée",
  "match.view.unlockedCards_other": "{count} cartes débloquées",
  "match.view.unlockedFoils_one": "{count} récompense foil débloquée",
  "match.view.unlockedFoils_other": "{count} récompenses foil débloquées",
  "match.view.bonusAvailable": "Bonus {bonus} disponible",
  "match.view.earned": "Gagné",
  "match.view.adPromptTitle": "Regarder une publicité ?",
  "match.view.adPromptBody": "Veux-tu regarder une courte publicité pour débloquer des variantes foil supplémentaires de cartes débloquées ? Nous utiliserons les revenus publicitaires pour couvrir les coûts des serveurs et le développement continu. Merci d'avance pour ton soutien !",
  "match.view.loading": "Chargement...",
  "match.view.adWatch": "Regarder la publicité",
  "match.view.notNow": "Pas maintenant",
  "match.view.none": "Aucun",
  "match.view.endedBy": "Fin par",
  "match.view.rounds": "Manches",
  "match.view.opponent": "Adversaire",
  "match.view.damageDealt": "Dégâts infligés",
  "match.view.damageTaken": "Dégâts subis",
  "match.view.healed": "Soins reçus",
  "match.view.throwAway": "Jeter",
  "match.view.reportChooseCategory": "Choisis une catégorie de signalement.",
  "match.view.chatTurnedOff": "Le chat est désactivé. Consulte les conditions du chat pour le réactiver.",
  "match.view.queueTitle": "Recherche d'une partie contre un joueur...",
  "match.view.playersInQueue": "Joueurs en file : {players}",
  "match.view.cancelQueue": "Quitter la file",
  "match.view.discardPileAria": "Défausse de {name}",
  "match.view.discardViewerHint": "Les plus récentes d'abord. Touche une carte pour l'examiner.",
  "match.view.discardEmpty": "Aucune carte dans la défausse.",
  "match.view.account.passwordTooShort": "Le mot de passe doit contenir au moins 4 caractères.",
  "match.view.account.passwordMismatch": "Les nouveaux mots de passe ne correspondent pas.",
  "match.view.account.passwordUpdated": "Mot de passe mis à jour.",
  "match.view.account.changePasswordFailed": "Impossible de changer le mot de passe.",
  "match.view.account.requestFailed": "La requête a échoué.",
  "match.view.account.typeUsernameToConfirm": "Saisis exactement ton nom d'utilisateur pour confirmer.",
  "match.view.account.enterCurrentPassword": "Saisis ton mot de passe actuel.",
  "match.view.account.deleteFailed": "Impossible de supprimer le compte.",
  "match.view.account.enterUsername": "Saisis un nom d'utilisateur.",
  "match.view.account.usernameNoSpaces": "Le nom d'utilisateur ne doit pas contenir d'espaces.",
  "match.view.account.createFailed": "Impossible de créer le compte.",
  "match.view.winnerBanner": "Vainqueur : {name}",
  "match.view.quickUseEquipment": "Utilisation rapide des équipements pour les ressources",
  "match.view.quickUseAbilities": "Utilisation rapide des capacités de dégâts",
  "match.view.hand": "Main",
  "match.view.noCardsInHand": "Aucune carte en main",
  "match.view.handHint": "Voici ta main. Tes decks d'équipement et de capacités sont mélangés ensemble. Tu peux avoir jusqu'à quatre cartes en main, complétées jusqu'au maximum au début de chacun de tes tours. Tu peux équiper une carte d'équipement par tour et effectuer un jeu de capacité par tour : la placer dans un emplacement vide, déplacer une capacité placée ou la retirer pour la remettre en main.",
  "match.guide.label": "Guide",
  "match.guide.show": "Afficher le guide",
  "match.guide.hide": "Réduire le guide",
  "match.guide.turnOff": "Désactiver les guides",
  "match.guide.turnedOff": "Guides de partie désactivés. Réactive-les dans les Paramètres.",
  "match.guide.title.openingHand": "Main de départ",
  "match.guide.title.yourTurn": "Ton tour",
  "match.guide.title.opponentTurn": "Tour de l'adversaire",
  "match.guide.title.makeChoice": "Fais un choix",
  "match.guide.mulligan": "Garde cette main, ou appuie une fois sur Mulligan pour repiocher. Appuie sur Prêt quand tu es paré.",
  "match.guide.mulliganWaiting": "En attente que ton adversaire soit prêt.",
  "match.guide.opponentTurn": "Observe ce que joue ton adversaire. Touche une carte pour l'examiner. Ta main se remplit au début de ton tour.",
  "match.guide.pendingChoice": "Termine le choix en surbrillance (choisis une cible ou une option), ou annule-le, avant de faire autre chose.",
  "match.guide.playEquipment": "Équiper : touche une carte Équipement brillante dans ta main et appuie sur Équiper (1 par tour).",
  "match.guide.slotAbility": "Capacité : touche une carte Capacité brillante dans ta main, appuie sur Placer, puis choisis un emplacement de capacité vide (1 par tour).",
  "match.guide.expendEquipment_one": "Dépenser : touche l'équipement brillant sur ton plateau pour obtenir des ressources ou son effet.",
  "match.guide.expendEquipment_other": "Dépenser : touche les équipements brillants sur ton plateau pour obtenir des ressources ou des effets ({count} prêts).",
  "match.guide.activateAbilities_one": "Activer : touche la capacité brillante sur ton plateau pour l'utiliser.",
  "match.guide.activateAbilities_other": "Activer : touche les capacités brillantes sur ton plateau pour les utiliser ({count} prêtes).",
  "match.guide.needResources": "Certaines capacités nécessitent plus de ressources. Dépense d'abord de l'équipement pour les payer.",
  "match.guide.nothingLeft": "Plus rien à jouer ni à utiliser. Appuie sur Fin du tour.",
  "match.guide.idle": "Bloqué ? Tu peux appuyer sur Fin du tour à tout moment.",
  "match.guide.invoke": "Facultatif : Invoque une carte de ta main en la défaussant pour son effet d'Invocation.",
  "match.view.viewingYourBoard": "Ton plateau",
  "match.view.viewingEnemies": "Ennemis",
  "match.view.viewingPlayerBoard": "Plateau de {name}",
  "match.view.cycleBoardView": "Changer de vue du plateau",
  "match.view.viewLabel": "Vue",
  "match.view.viewEnemy": "Ennemi",
  "match.view.viewAlly": "Allié",
  "match.view.viewOpp": "Adv.",
  "match.view.viewSelf": "Moi",
  "match.view.showMatchEmotes": "Afficher les emotes de partie",
  "match.view.hideAllMatchEmotes": "Masquer toutes les emotes de partie",
  "match.view.showEmotes": "Afficher les emotes",
  "match.view.hideEmotes": "Masquer les emotes",
  "match.view.emotes": "Emotes",
  "match.view.sendEmote": "Envoyer l'emote {emoji}",
  "match.view.mulliganed": "Mulligan effectué",
  "match.view.mulligan": "Mulligan",
  "match.view.closeEmotes": "Fermer les emotes",
  "match.view.openEmotes": "Ouvrir les emotes",
  "match.view.emote": "Emote",
  "match.view.ready": "Prêt",
  "match.view.cancelEffectUse": "Annuler l'utilisation de l'effet",
  "match.view.cancelAbilityUse": "Annuler l'utilisation de la capacité",
  "match.view.cancelEffectUseConfirm": "Annuler l'utilisation de l'effet ?",
  "match.view.cancelAbilityUseConfirm": "Annuler l'utilisation de la capacité ?",
  "match.view.skipAbilityLevelUpTitle": "Passer la montée de niveau de capacité pour +3 XP",
  "match.view.skip": "PASSER",
  "match.view.chooseAbilityOrSkipTitle": "Choisis une Capacité en surbrillance ou Passe avant de finir ton tour",
  "match.view.endTurnLine1": "FIN",
  "match.view.endTurnLine2": "DU TOUR",
  "match.view.skipEquipmentTraitTitle": "Passer le Trait d'équipement pour +3 XP",
  "match.view.chooseAbilityOrEquipmentOrSkipTitle": "Choisis une capacité ou un équipement en surbrillance, ou Passe, avant de finir ton tour",
  "match.view.chooseEquipmentOrSkipTitle": "Choisis un équipement en surbrillance ou Passe avant de finir ton tour",
  "match.view.chooseTraitLine1": "Choisir",
  "match.view.chooseTraitLine2": "un Trait",
  "match.view.viewBoardLine1": "Voir le",
  "match.view.viewBoardLine2": "plateau",
  "match.view.chooseTraitTitle": "Choisis un Trait avant de finir ton tour",
  "match.view.chooseIdentityLine1": "Choisir",
  "match.view.chooseIdentityLine2": "l'Identité",
  "match.view.chooseIdentityTitle": "Choisis une Identité avant de finir ton tour",
  "match.view.noResourcesSpent": "Aucune ressource ne sera dépensée.",
  "match.view.noRefund": "Le coût de {name} ne te sera pas remboursé.",
  "match.view.thisEffect": "cet effet",
  "match.view.keepTargeting": "Continuer le ciblage",
  "game.toast.error": "Erreur",
  "game.toast.yourTurn": "Ton tour",
  "game.toast.yourTurnOpeningBlocked": "Ton tour · Tu joues en premier, tu n'infliges donc aucun dégât à ton premier tour",
  "game.gameLog.exportFailed": "Impossible d'exporter le journal de partie.",
  "game.gameLog.copied": "Journal de partie copié dans le presse-papiers ({entries} entrées)",
  "game.gameLog.exported": "Journal de partie exporté ({entries} entrées)",
  "game.payment.kind.ability": "Capacité",
  "game.payment.kind.sharpen": "Aiguiser",
  "game.payment.kind.hone": "Affûter",
  "game.payment.kind.fletch": "Empennage",
  "game.payment.kind.encore": "Encore",
  "game.payment.kind.research": "Recherche",
  "game.payment.kind.repair": "Réparation",
  "game.deck.recommendStale": "Ton deck a changé. Relance la recommandation pour obtenir de nouveaux échanges.",
  "game.deck.recommendInvalid": "Ces échanges ne sont plus valides.",
  "game.deck.recommendApplied_one": "{count} échange appliqué. Enregistre pour le conserver.",
  "game.deck.recommendApplied_other": "{count} échanges appliqués. Enregistre pour les conserver.",
  "game.deck.limitReached": "Limite de decks atteinte.",
  "game.deck.imported": "{name} importé",
  "game.workshop.seatOpponent": "Adversaire",
  "game.workshop.seatYou": "Toi",
  "game.workshop.maxCopies": "{max} exemplaires maximum de {name}.",
  "game.workshop.addedToAbilityHand": "Ajoutée à la main de capacités. Sélectionne un emplacement.",
  "common.attribute.strength": "Force",
  "common.attribute.dexterity": "Dextérité",
  "common.attribute.wisdom": "Sagesse",
  "common.attribute.neutral": "Neutre",
  "deck.sort.name": "Nom",
  "deck.sort.category": "Catégorie",
  "deck.sort.type": "Type",
  "deck.sort.attribute": "Attribut",
  "deck.sort.resources": "Ressources",
  "deck.sort.cost": "Coût",
  "deck.sort.power": "Puissance",
  "deck.sort.slot": "Emplacement",
  "deck.sort.tier": "Rang",
  "deck.sort.kind": "Genre",
  "deck.sort.holo": "Nombre de holos",
  "match.quest.equip": "Équiper une carte Équipement",
  "match.quest.slotAbility": "Placer une carte Capacité",
  "match.quest.resourceExpend": "Gagner au moins 1 ressource",
  "match.quest.combatDamage": "Infliger des dégâts non bloqués",
  "match.quest.healBuff": "Obtenir un effet de soutien comme des soins ou de l'armure",
  "match.quest.fullEquipment": "Avoir un équipement dans les 3 emplacements en même temps",
  "match.quest.fullAbilities": "Avoir une capacité placée dans les 3 emplacements actifs ou principaux en même temps",
  "match.quest.equipAllSlots": "Équiper chaque emplacement d'équipement au moins une fois",
  "match.quest.activateLevel2Ability": "Activer une fois une Capacité placée de niveau 2",
  "match.quest.activateAugmentedAbility": "Activer une fois une Capacité avec une Augmentation correspondante",
  "match.questStep.weapon": "Arme",
  "match.questStep.trinket": "Bibelot",
  "match.questStep.body": "Corps",
  "match.questStep.hands": "Mains",
  "match.questStep.feet": "Pieds",
  "match.questStep.head": "Tête",
  "game.serverToast.mulliganFirstPlayer": "PHASE DE MULLIGAN - Le premier joueur sera {name}",
  "game.serverToast.ranOutOfTime": "Tu n'as plus de temps !",
  "match.lobby.backToMatch": "Retour à la partie",
  "match.lobby.classic": "Classique",
  "match.lobby.queueVsCpu": "File contre le CPU",
  "match.lobby.vsCpu": "CONTRE CPU",
  "match.lobby.playersInQueue_one": "Joueurs en file : {count}",
  "match.lobby.playersInQueue_other": "Joueurs en file : {count}",
  "match.lobby.queueVsHuman": "File contre un joueur",
  "match.lobby.vsHuman": "CONTRE JOUEUR",
  "match.lobby.cancelQueue": "Quitter la file",
  "match.lobby.enterQueueVsHuman": "Entrer en file contre un joueur",
  "match.lobby.playAgainstCpu": "Jouer contre le CPU",
  "match.lobby.setValidDeck": "Choisis un deck valide avant d'entrer en file.",
  "match.lobby.currentDeck": "Deck actuel :",
  "match.lobby.randomDeck": "🎲 Deck aléatoire",
  "match.lobby.randomDeckHint": "Un deck valide aléatoire sera choisi quand tu entreras en file.",
  "match.lobby.deckPreview": "Aperçu du deck",
  "match.lobby.noAspect": "Aucun Aspect",
  "match.lobby.modes": "Modes",
  "match.lobby.collectDraftRewards": "Récupérer les récompenses du Draft",
  "match.lobby.continueDraftMode": "Continuer le mode Draft",
  "match.lobby.playDraftModeFree": "Jouer en mode Draft (GRATUIT)",
  "match.lobby.playDraftModeCost": "Jouer en mode Draft ({cost} de monnaie)",
  "match.lobby.collectDraft": "Récupérer le Draft",
  "match.lobby.continueDraft": "Continuer le Draft",
  "match.lobby.draftFree": "Draft (GRATUIT)",
  "match.lobby.draft": "Draft",
  "match.lobby.continueAdventureMode": "Continuer le mode Aventure",
  "match.lobby.playAdventureMode": "Jouer en mode Aventure",
  "match.lobby.continueAdventure": "Continuer l'Aventure",
  "match.lobby.adventure": "Aventure",
  "match.lobby.tutorialScenarios": "Scénarios de tutoriel",
  "match.lobby.tutorials": "Tutoriels",
  "match.lobby.draftStatus": "Draft : {lives} vies · {played}/{max} parties · V {wins} / D {losses} / N {draws}",
  "match.lobby.draftRound": "Draft : manche {round}/{total}",
  "match.lobby.collectDraftFirst": "Récupère les récompenses du Draft avant de lancer une nouvelle session.",
  "match.popup.challengeTitle": "Défi",
  "match.popup.challengeBody": "{name} t'a défié à une partie.",
  "match.popup.partyInviteTitle": "Invitation de groupe",
  "match.popup.partyInviteBody": "{name} t'a invité dans un groupe d'Aventure.",
  "match.popup.leaveCpuTitle": "Quitter la partie contre le CPU ?",
  "match.popup.leaveCpuBody": "Abandonner la partie et la quitter pour accepter le défi ?",
  "match.popup.accept": "Accepter",
  "match.popup.decline": "Refuser",
  "match.popup.leaveSpectateTitle": "Quitter le mode spectateur ?",
  "match.popup.forfeitTitle": "Abandonner la partie ?",
  "match.popup.leaveSpectateBody": "Tu ne regarderas plus cette partie.",
  "match.popup.forfeitBody": "Tu perdras cette partie et la quitteras immédiatement.",
  "match.popup.leave": "Quitter",
  "match.popup.forfeit": "Abandonner",
  "match.popup.loseTitle": "Cela te fera perdre",
  "match.popup.loseBodyEquip": "Équiper {name} te fera perdre.",
  "match.popup.loseBodyActivate": "Activer {name} te fera perdre.",
  "match.popup.confirm": "Confirmer",
  "match.popup.disconnected": "Déconnecté",
  "match.popup.reconnecting": "Tu as été déconnecté, tentative de reconnexion...",
  "match.popup.hideHint": "Masquer l'astuce",
  "common.back": "Retour",
  "common.returnToMenu": "Retour au menu",
  "common.currencyAmount": "{amount} de monnaie",
  "draft.title": "Mode Draft",
  "draft.draftedCards": "Cartes draftées actuelles",
  "draft.aspectCount": "Aspect ({n})",
  "draft.equipmentCount": "Équipement ({n})",
  "draft.abilityCount": "Capacité ({n})",
  "draft.noneYet": "Aucune pour l'instant.",
  "draft.roundChoice": "Manche {round}/{total} · Choix : {kind}",
  "draft.forfeit": "Abandonner le Draft",
  "draft.pick": "Choisir",
  "draft.forfeitTitle": "Abandonner le Draft ?",
  "draft.forfeitBody": "Cela met fin à toute la session de Draft.",
  "draft.deckTitle": "Deck de Draft",
  "draft.deckStatus": "Vies {lives}/{maxLives} · Parties {played}/{maxGames} · V {wins} / D {losses} / N {draws}",
  "draft.deckCounts": "Aspect {aspect}/1 · Équipement {equipment}/{min} · Capacité {ability}/{min} · Réserve {poolAspect} aspect / {poolEquipment} équipement / {poolAbility} capacité",
  "draft.queueCpu": "File pour une partie Draft contre le CPU",
  "draft.queueHuman": "File pour une partie Draft contre un humain",
  "draft.buildHint": "Construis un deck de 10 équipements / 10 capacités avec tes cartes draftées.",
  "draft.complete": "Draft terminé",
  "draft.collectRewards": "Récupérer les récompenses",
  "draft.livesRemaining": "Vies restantes : {lives}",
  "draft.record": "V {wins} / D {losses} / N {draws}",
  "draft.games": "Parties : {games}",
  "draft.reward": "Récompense",
  "draft.wizardFoils": "Foils Draft Wizard : {n}",
  "draft.deckAspect": "Aspect du deck",
  "draft.deckEquipment": "Équipement du deck",
  "draft.deckAbility": "Capacité du deck",
  "draft.poolAspect": "Aspect de la réserve",
  "draft.poolEquipment": "Équipement de la réserve",
  "draft.poolAbility": "Capacité de la réserve",
  "draft.costToast": "Le mode Draft coûte {cost} de monnaie (ou est gratuit une fois par jour après 16 h, heure du Centre des États-Unis).",
  "adventure.title": "Mode Aventure",
  "adventure.hp": "{hp}/{maxHp} PV",
  "adventure.gold": "Or {gold}",
  "adventure.intention": "Intention : {intention}",
  "adventure.actsEvery_one": "Intervalle d'action : {count} tour",
  "adventure.actsEvery_other": "Intervalle d'action : {count} tours",
  "adventure.nextSuffix": " (suivant)",
  "adventure.intentNext": "Ensuite : {summary}",
  "adventure.intentIn": "Dans {turns} : {summary}",
  "adventure.unknown": "Inconnu",
  "adventure.attack": "Attaque",
  "adventure.attackDamage": "{damage} dégâts {type}",
  "adventure.attackHeal": "soigne {heal} ({target})",
  "adventure.healTargetAllies": "tous les alliés",
  "adventure.healTargetAlly": "un allié",
  "adventure.healTargetSelf": "soi-même",
  "adventure.damageType.physical": "physiques",
  "adventure.damageType.magical": "magiques",
  "adventure.damageType.fire": "de feu",
  "adventure.damageType.cold": "de froid",
  "adventure.damageType.lightning": "de foudre",
  "adventure.enemy": "Ennemi",
  "adventure.enemyType": "Type : {name}",
  "adventure.node": "Nœud",
  "adventure.nodeType.start": "Camp",
  "adventure.nodeType.combat": "Combat",
  "adventure.nodeType.shop": "Boutique",
  "adventure.nodeType.reward": "Trésor",
  "adventure.nodeType.story": "Histoire",
  "adventure.preview.unknown": "Rencontre inconnue.",
  "adventure.preview.combat": "Une rencontre de combat.",
  "adventure.preview.shop": "Une boutique.",
  "adventure.preview.reward": "Une cachette au trésor.",
  "adventure.preview.story": "Un événement narratif.",
  "adventure.chooseNodeTitle": "Choisir {name} ?",
  "adventure.travelNodeTitle": "Voyager vers {name} ?",
  "adventure.chooseUnknownTitle": "Choisir un nœud inconnu ?",
  "adventure.travelUnknownTitle": "Voyager vers un nœud inconnu ?",
  "adventure.pathHidden": "Le chemin reste caché jusqu'à ton arrivée.",
  "adventure.partyMustConfirm": "Les membres du groupe doivent confirmer avant le début de l'événement.",
  "adventure.fillDeckBeforeTravel": "Remplis ton Deck d'Aventure avec 10 cartes d'équipement et 10 cartes de capacité avant de voyager.",
  "adventure.choose": "Choisir",
  "adventure.travel": "Voyager",
  "adventure.fillEverySlot": "Remplis chaque emplacement du Deck d'Aventure avec des cartes de l'Inventaire avant de voyager. Chaque deck nécessite 10 cartes, avec au plus {max} exemplaires d'une même carte.",
  "adventure.waitingPartyConfirm": "En attente de la confirmation du groupe ({ready}/{total})",
  "adventure.confirmReady": "Confirmer : prêt",
  "adventure.effects": "Effets",
  "adventure.activeEffects": "Effets actifs",
  "adventure.noActiveEffects": "Aucun effet actif.",
  "adventure.inventoryCount": "Inventaire {n}/{max}",
  "adventure.defaultDeckName": "Paquetage du compagnon",
  "adventure.deckCounts": "{name} · Aspect {aspect}/1 · Équipement {equipment}/{min} · Capacité {ability}/{min}",
  "adventure.deckEditHint": "Touche un emplacement pour l'examiner, le vider ou le remplacer par une carte de l'Inventaire. Remplis chaque emplacement avec au plus {max} exemplaires de chaque carte pour voyager à nouveau.",
  "adventure.leave": "Laisser",
  "adventure.take": "Prendre",
  "adventure.party": "Groupe",
  "adventure.partyHint": "Invite des joueurs En ligne dans le menu du mode Aventure. Jusqu'à 4.",
  "adventure.partyLeader": "Chef : {name}",
  "adventure.leaderSuffix": " (Chef)",
  "adventure.invitedYou": "{name} t'a invité",
  "adventure.invite": "Inviter",
  "adventure.noEligible": "Aucun joueur éligible en ligne.",
  "adventure.leaveParty": "Quitter le groupe",
  "adventure.waitingParty": "En attente du groupe…",
  "adventure.combatSummary": "Résumé du combat",
  "adventure.resultGold": "{result} · Or gagné : {gold}",
  "adventure.enemiesDefeated_one": "{defeated} sur {count} ennemi vaincu",
  "adventure.enemiesDefeated_other": "{defeated} sur {count} ennemis vaincus",
  "adventure.rewards": "Récompenses",
  "adventure.rewardHint": "Touche une carte pour l'examiner · Clique sur Prendre pour mettre une récompense en file, ou sur Laisser pour la passer",
  "adventure.continueWhenReady": "Continue quand tu es prêt",
  "adventure.resolvingCombat": "Résolution du combat...",
  "adventure.shop": "Boutique",
  "adventure.shopHint": "Or {gold} · Touche une carte pour l'examiner",
  "adventure.buyGold": "Acheter pour {price} Or",
  "adventure.leaveShopWhenReady": "Quitte la boutique quand tu es prêt",
  "adventure.leaveShop": "Quitter la boutique",
  "adventure.treasure": "Trésor",
  "adventure.treasureHint": "Or {gold} · Touche une carte pour l'examiner · Clique sur Prendre pour mettre une récompense en file, ou sur Laisser pour la passer",
  "adventure.story": "Histoire",
  "adventure.youGain": "Tu obtiens : {effects}",
  "adventure.enteringCombat": "Début du combat…",
  "adventure.tabDeck": "Deck d'Aventure",
  "adventure.tabInventory": "Inventaire",
  "adventure.tabMap": "Carte",
  "common.player": "Joueur",
  "common.hoursMinutesShort": "{hours} h {minutes} min",
  "common.minutesShort": "{minutes} min",
  "social.report": "Signaler",
  "social.block": "Bloquer",
  "customize.board": "Plateau",
  "customize.nameColor": "Couleur du nom",
  "customize.lockedSuffix": " (Verrouillé)",
  "customize.unlockFor": "Débloquer {name} pour {cost}",
  "customize.confirmPurchase": "Touchez à nouveau pour acheter",
  "customize.boardName.flat": "Uni",
  "customize.boardName.elegant": "Élégant",
  "customize.boardName.ice": "Glace",
  "customize.boardName.nature": "Nature",
  "customize.boardName.volcanic": "Volcanique",
  "customize.boardName.castle": "Château",
  "customize.boardName.factory": "Usine",
  "customize.boardName.swamp": "Marais",
  "customize.colorName.garnet": "Grenat",
  "customize.colorName.scarlet": "Écarlate",
  "customize.colorName.amber": "Ambre",
  "customize.colorName.gold": "Or",
  "customize.colorName.verdant": "Verdoyant",
  "customize.colorName.forest": "Forêt",
  "customize.colorName.abyss": "Abysse",
  "customize.colorName.steel": "Acier",
  "customize.colorName.mist": "Brume",
  "customize.colorName.white": "Blanc",
  "customize.colorName.cyan": "Cyan",
  "customize.colorName.azure": "Azur",
  "customize.colorName.sand": "Sable",
  "customize.colorName.clay": "Argile",
  "customize.colorName.umber": "Terre d'ombre",
  "customize.colorName.plum": "Prune",
  "customize.colorName.rainbow_holo": "Holo arc-en-ciel",
  "customize.colorName.metallic_holo": "Holo métallique",
  "customize.colorName.gilded_holo": "Holo doré",
  "marketplace.refreshesIn": "Actualisation dans {time}",
  "marketplace.cards": "Cartes",
  "marketplace.foils": "Variantes foil",
  "marketplace.sold": "Vendu",
  "marketplace.buy": "Acheter",
  "marketplace.confirmBuy": "Confirmer l'achat",
  "marketplace.noCards": "Aucune carte verrouillée disponible.",
  "marketplace.noFoils": "Aucune variante foil disponible.",
  "marketplace.notEnough": "Pas assez de monnaie.",
  "achievements.title": "Succès",
  "achievements.close": "Fermer les succès",
  "achievements.ready": "Prêts : {n}",
  "achievements.completionReward": "Récompense d'accomplissement",
  "achievements.completionRewardCollected": "Récompense d'accomplissement récupérée",
  "achievements.none": "Aucun succès pour l'instant.",
  "achievements.collected": "Récupéré",
  "achievements.collect": "Récupérer",
  "achievements.collectCompletionTitle": "Récupérer la récompense d'accomplissement",
  "achievements.collectAllFirst": "Récupère d'abord tous les succès de cette catégorie.",
  "achievements.view": "Voir les succès",
  "achievements.dailies": "Quotidiennes",
  "achievements.dailiesHint": "Progresse dans les quotidiennes lors de n'importe quelle partie Classique",
  "achievements.emptySlot": "Emplacement vide",
  "achievements.untilNewDaily": "{time} avant une nouvelle quotidienne",
  "achievements.newDailyArriving": "Nouvelle quotidienne en approche...",
  "achievements.untilExpired": "{time} avant expiration",
  "achievements.removeAgainAria": "Appuie à nouveau pour retirer la quotidienne : {label}",
  "achievements.removeAria": "Retirer la quotidienne : {label}",
  "achievements.removeAgain": "Appuie à nouveau pour retirer",
  "achievements.remove": "Retirer la quotidienne",
  "achievements.rerollAgainAria": "Appuie à nouveau pour relancer la quotidienne pour {cost} de monnaie : {label}",
  "achievements.rerollAria": "Relancer la quotidienne pour {cost} de monnaie : {label}",
  "achievements.rerollAgain": "Appuie à nouveau pour relancer",
  "achievements.reroll": "Relancer cette quotidienne (une fois par quotidienne)",
  "achievements.loadingDailies": "Chargement des quotidiennes...",
  "dailies.dealDamage": "Inflige {target} dégâts {type}",
  "dailies.applyAilment": "Applique {target} de {ailment}",
  "dailies.gainResource": "Gagne {target} {attribute}",
  "dailies.playEquipment": "Joue {target} cartes Équipement",
  "dailies.playAbility": "Joue {target} cartes Capacité",
  "dailies.playAttribute": "Joue {target} cartes {attribute}",
  "dailies.playKind": "Joue {target} capacités {kind}",
  "dailies.playTag": "Joue {target} cartes {tag}",
  "dailies.winWithAspect_one": "Gagne {count} partie avec {name}",
  "dailies.winWithAspect_other": "Gagne {count} parties avec {name}",
  "dailies.expendDamage": "Dépense de l'équipement {target} fois pour infliger des dégâts",
  "dailies.expendEffect": "Dépense de l'équipement {target} fois pour un effet autre que des dégâts ou des ressources",
  "dailies.activateAbility": "Active une capacité active {target} fois",
  "dailies.invokeCards": "Invoque {target} cartes",
  "dailies.activateCard": "Active {name} {target} fois",
  "dailies.ailment.burn": "Brûlure",
  "dailies.ailment.poison": "Poison",
  "dailies.ailment.bleed": "Saignement",
  "dailies.ailment.shock": "Choc",
  "dailies.ailment.chill": "Froid",
  "dailies.ailment.wither": "Flétrissement",
  "match.portrait.closeAria": "Fermer l'examen du joueur",
  "match.portrait.deck": "Deck : {n}",
  "match.portrait.hand": "Main : {n}",
  "match.portrait.discard": "Défausse : {n}",
  "common.loading": "Chargement…",
  "common.ok": "OK",
  "common.loadingAssets": "Chargement des ressources {loaded}/{total}",
  "social.chatMuted": "Tu es réduit au silence et ne peux ni voir ni envoyer de messages.",
  "social.chatGuest":
    "Le chat nécessite un compte enregistré. Crée un compte ou migre vers un compte dans les Paramètres, puis reviens ici.",
  "social.chatLocked":
    "Le chat se débloque quand ton compte a au moins 24 heures, ou après {games} parties terminées sans abandon. Progression : {completed}/{games} parties terminées.",
  "social.chatLockedRemaining":
    "Le chat se débloque quand ton compte a au moins 24 heures, ou après {games} parties terminées sans abandon. Progression : {completed}/{games} parties terminées ({remaining} restantes).",
  "social.chatAgreeTerms":
    "Accepte les conditions du chat en jeu pour voir et envoyer des messages.",
  "social.players": "Joueurs",
  "social.playersOnline": "{online} / {total} en ligne",
  "social.showPlayers": "Afficher les joueurs",
  "social.hidePlayers": "Masquer les joueurs",
  "social.noPlayers": "Aucun joueur.",
  "social.noMessages": "Aucun message pour l'instant.",
  "social.messagePlaceholder": "Message",
  "social.reportTitle": "Signaler {name}",
  "social.reportPrompt":
    "Quel est le problème ? Les signalements sont privés et examinés par ATN DEV.",
  "social.reportCategory": "Catégorie de signalement",
  "social.reportCategoryName.harassment": "Harcèlement, intimidation ou menaces",
  "social.reportCategoryName.hate": "Discours haineux ou discrimination",
  "social.reportCategoryName.inappropriate": "Contenu sexuel ou inapproprié",
  "social.reportCategoryName.spam": "Spam ou arnaques",
  "social.reportCategoryName.cheating": "Triche ou exploitation de failles",
  "social.reportCategoryName.username": "Nom d'utilisateur offensant",
  "social.reportCategoryName.other": "Autre",
  "social.reportDetails": "Détails (facultatif)",
  "social.reportDetailsPlaceholder": "Décris brièvement ce qui s'est passé.",
  "social.reportChatIncluded":
    "Les messages de chat récents de ce joueur sont joints à ton signalement.",
  "social.reportBlockHint":
    "Tu peux aussi bloquer {name} pour masquer ses messages de chat et ses emotes.",
  "social.sending": "Envoi…",
  "social.submitReport": "Envoyer le signalement",
  "social.optIn.title": "Chat en jeu facultatif",
  "social.optIn.optional":
    "Le chat en jeu est facultatif. En acceptant, tu choisis de voir et d'envoyer des messages rédigés par les joueurs.",
  "social.optIn.notMonitored":
    "Les messages sont rédigés par les joueurs et ne représentent pas ATN DEV. Le chat n'est pas nécessairement modéré avant son affichage. Ne considère pas le chat comme privé ou confidentiel.",
  "social.optIn.conduct":
    "N'utilise pas le chat pour des menaces, du harcèlement, de la haine, des arnaques, du spam, des activités illégales ou toute autre conduite interdite. ATN DEV peut examiner les signalements et avertir, restreindre le chat, suspendre ou bannir des comptes.",
  "social.optIn.sensitive":
    "Ne partage pas de mots de passe, d'informations financières ou d'autres informations personnelles sensibles dans le chat.",
  "social.optIn.detailsBefore": "Tous les détails sont disponibles ici : ",
  "social.optIn.detailsAfter": ".",
  "social.optIn.agree": "J'accepte",
  "social.status.online": "En ligne",
  "social.status.offline": "Hors ligne",
  "social.status.recentlyOnline": "Récemment en ligne",
  "social.status.inCpuGame": "En partie contre le CPU",
  "social.status.inGame": "En partie",
  "social.status.spectating": "Spectateur",
  "social.status.inDraftQueue": "En file de Draft",
  "social.status.inQueue": "En file",
  "social.status.viewingQueue": "Consulte la file",
  "social.status.deckEditing": "Modifie un deck",
  "social.status.viewingCollection": "Consulte la collection",
  "social.status.viewingLibrary": "Consulte la bibliothèque",
  "social.status.viewingAchievements": "Consulte les succès",
  "social.status.viewingGlossary": "Consulte le glossaire",
  "social.status.adjustingSettings": "Règle les paramètres",
  "social.status.customizingBoard": "Personnalise son plateau",
  "social.status.inMarketplace": "Au Marché",
  "social.status.inSocial": "Dans Social",
  "social.status.viewingRanking": "Consulte le classement",
  "social.status.inWorkshop": "À l'Atelier",
  "social.status.viewingCommunity": "Consulte la communauté",
  "social.status.viewingSupport": "Consulte l'assistance",
  "social.status.viewingTutorials": "Consulte les tutoriels",
  "social.status.viewingSummary": "Consulte le résumé",
  "social.status.drafting": "En plein Draft",
  "social.status.buildingDraftDeck": "Construit un deck de Draft",
  "social.status.viewingDraftSummary": "Consulte le résumé du Draft",
  "social.status.adventureMode": "Mode Aventure",
  "social.status.adventureCombatSummary": "Résumé de combat d'Aventure",
  "social.status.inAdmin": "Dans l'administration",
  "social.status.watchingReplay": "Regarde une rediffusion",
  "social.draftMode": "Mode Draft",
  "social.bestDraftRun":
    "Meilleure session V {wins} / D {losses} / N {draws} · {lives} vies · {games} parties",
  "social.draftPool": "Réserve de Draft",
  "social.noDraftRun": "Aucune session de Draft terminée.",
  "social.spectateGame": "Regarder la partie",
  "social.blockedNotice":
    "Tu as bloqué ce joueur. Ses messages de chat et ses emotes sont masqués, et il ne peut pas te défier.",
  "social.noDecks": "Aucun deck.",
  "social.deckEquipmentPower": "Équipement · Puissance {power}",
  "social.deckAbilitiesPower": "Capacités · Puissance {power}",
  "ranking.cpuWinRatio": "Ratio de victoires contre le CPU",
  "ranking.humanWinRatio": "Ratio de victoires contre les humains",
  "ranking.cpuRecord": "CPU V/D/N",
  "ranking.humanRecord": "Humains V/D/N",
  "ranking.prev": "Préc.",
  "ranking.next": "Suiv.",
  "community.discordCopy": "Rejoins le Discord de Random's Projects.",
  "community.joinDiscord": "Rejoindre le Discord",
  "support.contactTitle": "Contact pour l'assistance ou le signalement de bugs",
  "support.contactCopy": "Contacte-nous par e-mail pour obtenir de l'aide ou signaler un problème.",
  "support.privacyPolicy": "Politique de confidentialité",
  "support.privacyCopy":
    "Quelles informations nous collectons, qui les reçoit, combien de temps nous les conservons et comment supprimer ton compte et tes données.",
  "support.privacyTitle": "Confidentialité et sécurité des données",
  "support.privacyHighlightCollect":
    "Nous collectons ton nom d'utilisateur, un mot de passe haché, ta progression de jeu et ton adresse IP avec une localisation approximative. Aucun e-mail n'est requis, et il n'y a aucun SDK d'analyse ou de publicité.",
  "support.privacyHighlightShare":
    "Nous ne vendons pas de données personnelles. Seuls nos fournisseurs d'hébergement, de géolocalisation IP et d'e-mail les traitent pour notre compte.",
  "support.privacyHighlightChat":
    "Le chat est facultatif, visible par les joueurs qui l'ont activé, et supprimé au plus tard après 90 jours.",
  "support.privacyHighlightDelete":
    "Supprime ton compte à tout moment dans Paramètres > Compte, sur le web ou par e-mail.",
  "support.privacyRead": "Lire la politique de confidentialité",
  "support.privacyOpenWeb": "Ouvrir la version web",
  "support.privacyDeletePage": "Page de suppression de compte",
  "support.privacyPublicNote":
    "Les deux pages sont publiques sur aeternainvicta.com/privacy et aeternainvicta.com/delete-account et fonctionnent sans l'application. Demandes relatives à la confidentialité : {email}.",
  "support.monetization": "Informations sur la monétisation",
  "support.monetizationCopy":
    "Comment le jeu est développé, quelles publicités et quelle Monnaie sont proposées, et notre engagement contre le pay-to-win.",
  "support.designPhilosophy": "Philosophie de conception",
  "support.designPhilosophyCopy":
    "Une courte lettre du concepteur sur l'idée à l'origine du jeu.",
  "support.designPhilosophyButton":
    "En savoir plus sur l'idée à l'origine d'Aeterna Invicta",
  "support.credits": "Crédits et remerciements",
  "support.creditsCopy":
    "Les amis, les testeurs et l'éditeur qui ont rendu tout cela possible.",
  "support.entryTitle.about": "À propos d'Aeterna Invicta",
  "support.entryTitle.ageRating": "Classification par âge et avertissement sur le contenu",
  "support.entryTitle.community": "Règles de la communauté et sécurité",
  "support.entryTitle.terms": "Conditions d'utilisation",
  "support.entryTitle.accountData": "Comptes et suppression des données",
  "support.entrySummary.about":
    "Ce qu'est le jeu, comment on y joue et qui le crée.",
  "support.entrySummary.ageRating":
    "Destiné aux joueurs de 13 ans et plus. Contient de la violence fantastique et des représentations de sang.",
  "support.entrySummary.community":
    "Comment rester en sécurité, ce qui est interdit et comment signaler un problème.",
  "support.entrySummary.terms":
    "Les règles d'utilisation du jeu, de ton compte et des objets en jeu.",
  "support.entrySummary.accountData":
    "Jeu en tant qu'invité, comptes enregistrés et comment supprimer ton compte et tes données.",
  "support.contact.type": "Type",
  "support.contact.bug": "Signalement de bug",
  "support.contact.email": "E-mail (pour une réponse)",
  "support.contact.bugPrompt":
    "Décris ce que tu faisais et ce qui se passait quand le bug est survenu.",
  "support.contact.helpPrompt": "Comment pouvons-nous t'aider ?",
  "support.contact.send": "Envoyer",
  "support.contact.sentTitle": "Message envoyé",
  "support.contact.enterEmail": "Saisis une adresse e-mail valide.",
  "support.contact.enterMessage": "Saisis un message.",
  "support.contact.sendFailed": "Échec de l'envoi. Réessaie.",
  "support.contact.confirmation":
    "Pour finaliser la prise de contact, envoie l'e-mail préparé à {email} depuis ton service de messagerie.",
  "lore.readMore": "Lire la suite",
  "rulebook.title": "Livre de règles d'Aeterna Invicta",
  "rulebook.contents": "Sommaire",
  "rulebook.tableOfContents": "Table des matières",
  "support.privacyLoadFailed": "Impossible de charger la politique de confidentialité.",
  "social.reportSubmitted":
    "Signalement envoyé. Merci de contribuer à la sécurité d'Aeterna Invicta.",
  "social.reportFailed": "Impossible d'envoyer le signalement.",
  "social.playerFallback": "joueur",
  "social.partyInviteSent": "Invitation de groupe envoyée à {name}.",
  "social.challengeSent": "Défi envoyé à {name}.",
  "social.challengeDeclined": "Défi refusé.",
  "social.challengeDeclinedBy": "{name} a refusé ton défi.",
  "account.createdSignInRequired": "Compte créé, mais la connexion est requise.",
  "account.createdPlayingAs": "Compte créé. Tu joues en tant que {name}.",
  "library.collection": "Collection",
  "library.rulebook": "Livre de règles",
  "library.glossary": "Glossaire",
  "library.lore": "Univers",
  "library.intro":
    "Parcours ta collection et des decks d'exemple, recherche des mots-clés et des mécaniques, ou lis l'histoire du royaume.",
  "library.decksIntro":
    "Des decks d'exemple à consulter pour t'inspirer ou à exporter pour les utiliser si tu as débloqué les cartes.",
  "library.missingCards": "Cartes manquantes dans ta collection",
  "library.noDecks": "Aucun deck de bibliothèque disponible.",
  "library.resetDecks": "Réinitialiser les decks",
  "library.resetDecksTitle": "Réinitialiser les decks ?",
  "library.resetDecksBody":
    "Cela remplace tous tes decks enregistrés par les decks de la Bibliothèque dont tu possèdes toutes les cartes. Les decks personnalisés et les modifications seront perdus.",
  "library.export": "Exporter",
  "library.deckAbilityPower": "Capacité · Puissance {power}",
  "glossary.backToSearch": "Retour à la recherche",
  "glossary.relatedCards": "Cartes associées ({n})",
  "glossary.noRelatedCards": "Aucune carte associée trouvée.",
  "glossary.search": "Recherche",
  "glossary.searchPlaceholder": "Mots-clés, termes, mécaniques",
  "glossary.noMatches": "Aucun terme correspondant.",
  "patchNotes.title": "Notes de mise à jour",
  "workshop.showControls": "Afficher les commandes",
  "workshop.hideControls": "Masquer les commandes",
  "workshop.addCard": "Ajouter une carte",
  "workshop.yourTurn": "Ton tour",
  "workshop.opponentTurn": "Tour de l'adversaire",
  "workshop.reset": "Réinitialiser",
  "workshop.hp": "PV {hp}/{maxHp}",
  "workshop.switchAspectFor": "Changer l'Aspect de {name}",
  "workshop.addCardTo": "Ajouter une carte à {name}",
  "workshop.chooseAspect": "Choisis un Aspect pour ce siège.",
  "workshop.maxCopiesPerSide": "{max} exemplaires maximum d'une même carte par camp.",
  "gamepad.connected": "Manette connectée",
  "gamepad.statusTitle": "{pad} · Select bascule entre barre de navigation et vue",
  "gamepad.ariaNav": "Manette connectée, barre de navigation sélectionnée",
  "gamepad.ariaView": "Manette connectée, vue sélectionnée",
  "gamepad.padNav": "Manette · Nav",
  "gamepad.padView": "Manette · Vue",
  "gamepad.connectedToast": "Manette connectée : {label}",
  "card.statusEffect": "Effet de statut",
  "card.empoweredPhysicalArmor": "Renforcé : Armure physique +{amount} (Trait, tant qu'équipé)",
  "card.empoweredMagicArmor": "Renforcé : Armure magique +{amount} (Trait, tant qu'équipé)",
  "card.levels": "Niveaux",
  "card.level": "Niveau",
  "card.cost": "Coût",
  "card.tapToReturn": "Touche pour renvoyer la carte",
  "card.powerN": "Puissance {power}",
  "card.locked": "Verrouillé",
  "match.board.needResource": "Il faut {need} {attribute} (tu en as {have})",
  "match.board.needHealth": "Il faut {need} de santé (tu en as {have})",
};

export default fr;
